import { render, staticRenderFns } from "./issueregistdetail.vue?vue&type=template&id=ff7cd568&scoped=true&"
import script from "./issueregistdetail.vue?vue&type=script&lang=js&"
export * from "./issueregistdetail.vue?vue&type=script&lang=js&"
import style0 from "./issueregistdetail.vue?vue&type=style&index=0&id=ff7cd568&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7cd568",
  null
  
)

export default component.exports